'use client';

import Icons from '@ant-design/icons';

import type { ReactClassNameInterface } from '@/types/common';

export interface IProps extends ReactClassNameInterface {
  component: any;
}

export default function Icon(props: IProps): JSX.Element {
  const { className, component } = props;

  return <Icons className={className} component={component} />;
}
